import { useEffect, useState, ChangeEvent, useMemo } from 'react';
import { FormGroup, FormControlLabel } from '@mui/material';
import { FilterButton, Checkbox } from '@care/react-component-lib';
import { decode } from 'he';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { PROVIDER_AGES } from '@/constants';
import { saveFilters } from '../../../utils/filtersStorage';

interface Props {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
}

const Age = (props: Props) => {
  // Build initial schedule state based on PROVIDER_AGES
  const defaultAges: { [key: string]: boolean } = useMemo(() => {
    return PROVIDER_AGES.reduce((accum: { [key: string]: boolean }, age) => {
      const ages = accum;
      // Add a new entry to the object and set its default value as false
      ages[age.value] = false;
      return ages;
    }, {});
  }, []);

  const { handleClick, isClear, onChange } = props;
  const [state, setState] = useState(defaultAges);
  const [isSelected, setIsSelected] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  // create an array of checkbox names that are checked
  const getCheckedOptions = (allCheckboxes: { [key: string]: boolean }) => {
    return Object.entries(allCheckboxes).reduce((prevVal: string[], curVal: [string, boolean]) => {
      // if the item is checked, add it
      if (curVal[1]) {
        prevVal.push(curVal[0]);
      }
      return prevVal;
    }, []);
  };

  const handleApply = () => {
    const checkedOptions = getCheckedOptions(state);
    const ageData = {
      ages: checkedOptions,
    };

    setIsSelected(checkedOptions.length > 0);
    saveFilters(ageData, onChange);

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, ageData);
  };

  useEffect(() => {
    if (isClear) {
      setState(defaultAges);
      setIsSelected(false);
    }
  }, [isClear, defaultAges]);

  return (
    <FilterButton
      label="Age"
      field="interactive-component"
      selected={isSelected}
      onApply={handleApply}
      onClick={handleClick}
      sx={{ color: 'text.primary' }}>
      <FormGroup>
        {PROVIDER_AGES.map((age) => {
          return (
            <FormControlLabel
              key={age.value}
              control={
                <Checkbox name={age.value} onChange={handleChange} checked={state[age.value]} />
              }
              label={decode(age.label)}
            />
          );
        })}
      </FormGroup>
    </FilterButton>
  );
};

export default Age;
